import './Footer.css'

const Footer = () => {
    return (
        <section id="footer_section">
            <div id="footer_container">
                <div id="footer_wrapper">
                    <p id="footer_left_text">&copy; 2023 There is no copyright.  &#xb7;   <a href="https://www.airbnb.com/help/article/2908" target="_blank">Terms</a> &#xb7;     <a href="https://www.airbnb.com/help/article/2855" target="_blank">Privacy</a> &#xb7; <a href="https://www.justindiner.com" target="_blank">Portfolio</a> &#xb7; <a href="https://github.com/Justin-Diner" target="_blank">Github</a> &#xb7; <a href="https://www.linkedin.com/in/justin-diner/" target="_blank">LinkedIn</a> &#xb7; <a href="https://twitter.com/IntoCode" target="_blank">Twitter</a></p>
                    <p id="footer_right_text">Technologies: React &#xb7; Redux &#xb7; JavaScript &#xb7; Ruby &#xb7; Ruby on Rails &#xb7; PostgreSQL &#xb7; AWS (S3) &#xb7; Currency: English (US)   $ USD </p>
                </div>
            </div>
        </section>
    )
}

export default Footer